var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M6.667,4.579V18H5V3h5V4.579Z",
    transform: "translate(-0.833 -0.5)",
    style: {
      opacity: 0.3
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    fillRule: "evenodd",
    d: "M9.982,2.245l6.667,1.208a.833.833,0,0,1,.685.82v12.2a.833.833,0,0,1-.685.82L9.982,18.5A.833.833,0,0,1,9,17.679V3.065a.833.833,0,0,1,.982-.82Zm1.449,8.882a1.136,1.136,0,1,0-1.042-1.133A1.09,1.09,0,0,0,11.431,11.127Z",
    transform: "translate(-1.5 -0.372)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.909f8e29c66480b2cc98bca2b1a54013.svg";
export { ForwardRef as ReactComponent };